import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center flex-wrap gap-2 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      to: "/profile/user-profile",
      class: "btn btn-outline-primary py-2 px-3 fw-medium"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(" Profile ")
      ])),
      _: 1
    }),
    _createVNode(_component_RouterLink, {
      to: "/profile/teams",
      class: "btn btn-outline-primary py-2 px-3 fw-medium"
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode(" Team ")
      ])),
      _: 1
    }),
    _createVNode(_component_RouterLink, {
      to: "/profile/my-projects",
      class: "btn btn-outline-primary py-2 px-3 fw-medium"
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode(" Projects ")
      ])),
      _: 1
    })
  ]))
}